import { sendEmail } from '../customFunctions'
import { dateDisplayFromString } from '../helpers'
import * as firebase from 'firebase'

// import { createHashHistory } from 'history'
//   const history = createHashHistory()

export const cancelCourse = (courseId, course, students, reason) => {
  const updates = {
    [`courseDetails/cancelled/${courseId}`]: true,
    [`courseDetails/upcoming/${courseId}`]: null,
    [`courseDetails/completed/${courseId}`]: null,
    [`courseDetails/in_progress/${courseId}`]: null,
    [`courses/${courseId}/status`]: 'cancelled',
  }

  Object.keys(course.students).map(studentId => {
    updates[`students/${studentId}/courses/${courseId}/status`] = 'cancelled'
  })

  const studentEmails = students.map(student => student.email)
  const emailMessage = `<p>Bună ziua,</p>
  <p>Vă scriem acest mesaj pentru a vă anunța anularea cursului ${
    course.name
  } din data de ${dateDisplayFromString(course.date)}.</p>
  <p>${reason}</p>
  <p>Vă mulțumim,</p>
  <p>Ordinul Asistenților</p>`

  sendEmail({
    emails: studentEmails,
    subject: `IMPORTANT - Anulare curs "${course.name}"`,
    message: emailMessage,
  })
    .then(res => console.log(res.data))
    .catch(err => console.error(err))

  firebase
    .database()
    .ref()
    .update(updates)
    .then(() => window.location.reload())
}



// WEBPACK FOOTER //
// ./src/actions/coursesActions.js